import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ProductWizardTile, usePopoverHandlers } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS } from '@as-react/common-types';
import { axiosClient } from '@as-react/common-utils';
import { useState, useEffect } from 'react';
import { ProductWizard } from '../../components/product-wizard/ProductWizard';
import { useOAuth } from '../../hooks/useOAuth';
const ProductWizardContainer = ({ path, trigger }) => {
    const { defaultRequestParams, fredHopperSearchUrl, isShopLanding } = useAemConfig();
    const [data, setData] = useState();
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const { isLoggedIn } = useOAuth();
    const loadProductWizardData = () => __awaiter(void 0, void 0, void 0, function* () {
        const axiosConfig = {
            method: 'GET',
            url: path,
            withCredentials: true,
        };
        try {
            const response = yield axiosClient.request(axiosConfig);
            return response.data;
        }
        catch (_a) {
            return;
        }
    });
    const fetchSearchResults = (filter) => __awaiter(void 0, void 0, void 0, function* () {
        const axiosConfig = {
            method: 'GET',
            params: {
                anaLang: defaultRequestParams.anaLang,
                fictiveWebShop: defaultRequestParams.shopId,
                locale: defaultRequestParams.language,
                mainWebShop: defaultRequestParams.mainWebshop,
                platform: isShopLanding
                    ? PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS.shoplanding
                    : PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS.public_site,
            },
            url: `${fredHopperSearchUrl}?filter=${filter}`,
            withCredentials: true,
        };
        try {
            const response = yield axiosClient.request(axiosConfig);
            return response.data.itemCount;
        }
        catch (_a) {
            return undefined;
        }
    });
    const openProductWizard = () => __awaiter(void 0, void 0, void 0, function* () {
        const productWizardData = yield loadProductWizardData();
        if (productWizardData) {
            setData(productWizardData);
        }
    });
    useEffect(() => {
        data && handlePopoverOpen(null, null, true);
    }, [data]);
    return (_jsxs(_Fragment, { children: [_jsx(ProductWizardTile, Object.assign({}, trigger, { onClick: openProductWizard })), data && (_jsx(ProductWizard, { fetchSearchResults: fetchSearchResults, productWizardData: data, anchorEl: anchorEl, handlePopoverClose: handlePopoverClose, loggedIn: isLoggedIn }))] }));
};
export default ProductWizardContainer;
